var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHisSuccessTickIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.9044 21.3489L30.9173 46.336L17.3052 32.7618L11.959 38.1081L30.9173 57.0664L61.2506 26.7331L55.9044 21.3489ZM38.5006 0.191406C17.5707 0.191406 0.583984 17.1781 0.583984 38.1081C0.583984 59.0381 17.5707 76.0247 38.5006 76.0247C59.4306 76.0247 76.4173 59.0381 76.4173 38.1081C76.4173 17.1781 59.4306 0.191406 38.5006 0.191406ZM38.5006 68.4414C21.7415 68.4414 8.16732 54.8672 8.16732 38.1081C8.16732 21.3489 21.7415 7.77474 38.5006 7.77474C55.2598 7.77474 68.834 21.3489 68.834 38.1081C68.834 54.8672 55.2598 68.4414 38.5006 68.4414Z",
    fill: "#2ABF86"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHisSuccessTickIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HIS_Success_Tick_Icon.56dbb493.svg";
export { ForwardRef as ReactComponent };